import { renderTemplate } from '../../Utils/templateUtils';

export default class AgentsApi
{
    constructor(dashApi) {
        this.DashAPI = dashApi;
        this.DashAPI.ApiPathMgr.add(AgentsApi.AgentsPath);
        this.DashAPI.ApiPathMgr.add(AgentsApi.TestimonialsByAgentIdPath);
        this.DashAPI.ApiPathMgr.add(AgentsApi.SocialMediaByAgentUserNamePath);
    }

    getAgents() {
        return this.DashAPI.CORE.get(AgentsApi.AgentsPath);
    }

    getAgentById(agentId) {
        return this.DashAPI.CORE.get(AgentsApi.AgentsPath + '/' + agentId);
    }

    getAgentsSitemap() {
        return this.DashAPI.CORE.getXML(AgentsApi.AgentsPath + '/sitemap');
    }

    getTestimonialsByAgentId(id) {
        var urlPath = renderTemplate(AgentsApi.TestimonialsByAgentIdPath, { agentId: id });
        return this.DashAPI.CORE.get(urlPath);
    }

    getAgentSocialMediaPosts(instagramUserName) {
        var urlPath = renderTemplate(AgentsApi.SocialMediaByAgentUserNamePath, { instagramUserName: instagramUserName });
        return this.DashAPI.CORE.get(urlPath);
    }
}

AgentsApi.AgentsPath = '/api/agents';
AgentsApi.TestimonialsByAgentIdPath = '/api/agents/{agentId}/testimonials';
AgentsApi.SocialMediaByAgentUserNamePath = '/api/agents/{instagramUserName}/socialmedia/?captioncontains=Paragon';



// WEBPACK FOOTER //
// ./src/PublicApi/agents/AgentsApi.js


// WEBPACK FOOTER //
// webpack:///src/PublicApi/agents/AgentsApi.js